import { render, staticRenderFns } from "./sport-top-banner.vue?vue&type=template&id=324747a2"
import script from "./sport-top-banner.vue?vue&type=script&lang=js"
export * from "./sport-top-banner.vue?vue&type=script&lang=js"
import style0 from "./sport-top-banner.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-top-banner.vue
// module id = +S/a
// module chunks = 0